import { useTranslation } from "react-i18next";
import Button from "../../../components/Button/Button";
import Buttons from "../../../components/Button/button.component";
import { colors } from "../../../theme/color";
import { ButtonContainer } from "../General/ButtonHolder.styles";
import ServiceBubble from "../General/ServiceBubble/ServiceBubble";
import {
  RecieveMoneyRightContainer,
  RecieveMoneyRightTextHolder,
  SubtitleText,
  TitleText,
} from "./RecieveMoneyRight.styles";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../locales/localeSlice";
import { useNavigate } from "react-router-dom";

const RecieveMoneyRight = () => {
  const navigate = useNavigate();
  const redirectToSignup = () => {
    navigate("/auth/signup");
  };
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <RecieveMoneyRightContainer>
      <ServiceBubble
        label={t("receiveSection.paymentInvoice", { lng: currentLocale })}
        position="flex-start"
        backgroundColor="rgba(255, 255, 255, 1)"
      />
      <RecieveMoneyRightTextHolder>
        <TitleText>
          {t("receiveSection.subTitle", { lng: currentLocale })}
        </TitleText>
        <SubtitleText>
          {t("servicesSection.subtitleTextOne", { lng: currentLocale })}
          {t("servicesSection.subtitleTextTwo", { lng: currentLocale })}
        </SubtitleText>
        <SubtitleText>
          {t("servicesSection.subtitleTextOne", { lng: currentLocale })}
          {t("servicesSection.subtitleTextTwo", { lng: currentLocale })}
        </SubtitleText>
      </RecieveMoneyRightTextHolder>
      <ButtonContainer>
        <Button
          id={""}
          type={"button"}
          disabled={false}
          onClick={redirectToSignup}
          padding={"10px 30px"}
          title={t("servicesSection.buttonLabel", { lng: currentLocale })}
          navyBlue
        />
      </ButtonContainer>
    </RecieveMoneyRightContainer>
  );
};

export default RecieveMoneyRight;
